import fetchIntercept from 'fetch-intercept';

/**
 * Class RequestLoader.js
 *
 * @class RequestLoader
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/manager/RequestLoader.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default class RequestLoader {
  constructor(store, stalkCursor) {
    /** @type string */
    this._store = store
    this._stalkCursor = stalkCursor;
    this._processesRunning = 0;

    interceptRequests(this)
    if (this._stalkCursor) enableVirtualCursorStalking(store)
  }

  increment() {
    this._store.commit('setLoadingCount', ++this._processesRunning)
    if (this._stalkCursor) moveVirtualCursorToPointer(this._store)
  }

  decrement() {
    if (this._processesRunning > 0)
      this._store.commit('setLoadingCount', --this._processesRunning)
  }

  clear() {
    if (this._processesRunning > 0)
      this._store.commit('setLoadingCount', 0)
  }
}

function interceptRequests(requestLoader) {
  fetchIntercept.register({
      request: function (url, config) {
        requestLoader.increment()
        return [url, config];
      },
      response: function (response) {
        requestLoader.decrement()
        return response;
      },
      responseError: function (error) {
        requestLoader.decrement()
        return Promise.reject(error);
      }
    }
  )
}

let $cursor = null, pageX = 0, pageY = 0;

const cursorOffset = {
  left : 35,
  top  : 35,
}

function setCursor(){
  $cursor = document.getElementById('virtual-cursor')
  if ($cursor) $cursor.classList.add('found')
}

function enableVirtualCursorStalking(store) {
  document.body.addEventListener("mousemove", function (e) {
    pageX = e.pageX
    pageY = e.pageY
    moveVirtualCursorToPointer(store)
  }, false);
}

function moveVirtualCursorToPointer(store){
  if (store.state.loadingCount){
    if (!$cursor) setCursor();

    if ($cursor){
      $cursor.style.left = (pageX - cursorOffset.left) + 'px';
      $cursor.style.top = (pageY - cursorOffset.top) + 'px';
    }
  }
}